/**
 * Endkundenrechner API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Vertragslaufzeit in Jahren.
 */
export enum Laufzeit {

    L1Jahr = 'L1Jahr',

    L3Jahre = 'L3Jahre',

    L5Jahre = 'L5Jahre'
}

